import React from 'react';
import Heading from '@amzn/meridian/heading';
import Text from '@amzn/meridian/text';
import Row from '@amzn/meridian/row';
import Tooltip from '@amzn/meridian/tooltip';
import Box from '@amzn/meridian/box';
import infoKnockoutTokens from '@amzn/meridian-tokens/base/icon/info-knockout';
import Icon from '@amzn/meridian/icon';
import { chainWalk } from '../../utils/helpers';

const RolloverVolumeView = ({ shiftPlanDynamic, selectedCycle }) => {
  const rolloverKey = 'ROLLOVER_VOLUME_' + selectedCycle;
  const rolloverVolume = chainWalk(() => shiftPlanDynamic['output']['warnings'][rolloverKey], '-');

  return (
    <Box type="outline" spacingInset="400">
      <div>
        <div className="overview-fph">
          <Heading level={2} type="h300" alignment="left">
            Rollover Volume
            <Tooltip position="end" title="for the selected cycle">
              <Icon className={'custom-tool-tip'} tokens={infoKnockoutTokens} />
            </Tooltip>
          </Heading>
        </div>
        <Row width="100%">
          <div>
            <Text type="d50">{rolloverVolume}</Text>
            <Text type="b100">Packages</Text>
          </div>
        </Row>
      </div>
    </Box>
  );
};

export default RolloverVolumeView;
